import axios from 'axios';
import { createSign } from './sign'
// import state from '../../store/index.js'
// const loading = state.state.isLoading
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
});
// 请求拦截器
service.interceptors.request.use(
  config => {
    if (!(config.url.indexOf('ReportMediaEvents') > -1)) {
      // state.commit('setIsLoading', true)
    }
    // 可以在这里添加请求头等信息
    // 例如：config.headers['Authorization'] = 'Bearer your-token';
    config = createSign(config)
    return config;
  },
  error => {
    // 请求错误处理
    console.log(error); // for debug
    Promise.reject(error);
  }
);
 
// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做处理，例如只返回data部分
    // state.commit('setIsLoading', false)
    const res = response.data;
    // 如果返回的状态码为200，说明成功，可以直接返回数据
    if (res.status === 200) {
      return res.response;
    } else {
      // 其他状态码都当作错误处理
      // 可以在这里对不同的错误码进行不同处理
      return Promise.reject({
        message: res.message || 'Error',
        status: res.code
      });
    }
  },
  error => {
    // 对响应错误做处理
    console.log('err' + error); // for debug
    return Promise.reject(error);
  }
);
 
export default service;
